import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 3rem 3rem;

  p + p {
    margin-top: 20px;
  }

  > p {
    font-size: 18px;
    color: #071242;
    max-width: 1040px;
    margin: 0 auto;
  }

  a {
    color: #202a55;
    &:hover {
      color: #df8c07;
      transition: color 0.3s ease-out;
    }
  }
`;
